import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap"
import React from "react"
import { LessonActivity } from "./lesson-activity.types"
import { Session } from "../session"


export interface ActivityCardContextMenuProps {

  activity: LessonActivity,
  sessionData: Session

  moveActivity?: {
    enabled: boolean
    onActivate: () => unknown
  }
  previewActivity?: {
    enabled: boolean
    onActivate: () => unknown
  }
  deleteActivity?: {
    enabled: boolean
    onActivate: () => unknown
  }
  manualMarkActivity?: {
    enabled: boolean
    onActivate: () => unknown
  }
  addNextActivity?: {
    enabled: boolean
    onActivate: () => unknown
  }
  addNextActivityToHomework?: {
    enabled: boolean
    onActivate: () => unknown
  }
  viewActivity?: {
    enabled: boolean
    onActivate: () => unknown
  }
  addNewTask?: {
    enabled: boolean
    onActivate: () => unknown
  }
  addComment?: {
    enabled: boolean
    onActivate: () => unknown
  }
  copyToHomework?: {
    enabled: boolean
    onActivate: () => unknown
  }
  moveToHomework?: {
    enabled: boolean
    onActivate: () => unknown
  }
  copyToLessonPlan?: {
    enabled: boolean
    onActivate: () => unknown
  }
  moveToLessonPlan?: {
    enabled: boolean
    onActivate: () => unknown
  }
  edit?: {
    enabled: boolean
    onActivate: () => unknown
  }

}

export const ActivityCardContextMenu = (props: ActivityCardContextMenuProps)=>{

  const [contextMenuOpen, setContextMenuOpen] = React.useState<boolean>(false)
  const { activity, sessionData } = props
  const { moveActivity, copyToHomework, previewActivity, deleteActivity, manualMarkActivity } = props
  const { addNextActivity, addNextActivityToHomework, moveToHomework, copyToLessonPlan, moveToLessonPlan } = props
  const { viewActivity, addNewTask, addComment, edit } = props



  return (
    <>
      <Dropdown
        isOpen={contextMenuOpen}
        toggle={() => setContextMenuOpen(!contextMenuOpen)}
      >
        <DropdownToggle className="p-0 bg-transparent mb-0">
          <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
        </DropdownToggle>

        <DropdownMenu className="custom-position">

          {manualMarkActivity?.enabled &&
            <>
              <DropdownItem
                onClick={()=> manualMarkActivity.onActivate()}
              >
                  <span>
                    <i className="mdi mdi-checkbox-marked-circle-outline font-size-15 me-1"></i>
                  </span>{" "}
                Mark
              </DropdownItem>
            </>
          }

          {sessionData?.session?.ses_is_completed === 1 &&
            <>
              {moveActivity?.enabled && <DropdownItem
                onClick={() => moveActivity.onActivate()}
              >
                  <span>
                    <i className="mdi mdi-calendar-arrow-right font-size-15 me-1"></i>
                  </span>{" "}
                Roll over to next session
              </DropdownItem>}{" "}
            </>
          }

          {copyToLessonPlan?.enabled && <DropdownItem
            onClick={() => copyToLessonPlan.onActivate()}
          >
              <span>
                <i className="mdi mdi-book-open-outline font-size-15 me-1"></i>
              </span>{" "}
            Copy To Lesson Plan
          </DropdownItem>}


          {activity.marked_for_homework === 0 &&
            <>
              {copyToHomework?.enabled && <DropdownItem
                onClick={() => copyToHomework.onActivate()}
              >
                  <span>
                    <i className="mdi mdi-home-edit-outline font-size-15 me-1"></i>
                  </span>{" "}
                Copy to homework
              </DropdownItem>}{" "}
            </>
          }

          {addNextActivity?.enabled && <DropdownItem
            onClick={() => addNextActivity.onActivate()}
          >
              <span>
                <i className="mdi mdi-skip-next font-size-15 me-1"></i>
              </span>{" "}
            Add the next activity
          </DropdownItem>}

          {addNextActivityToHomework?.enabled && <DropdownItem
            onClick={() => addNextActivityToHomework.onActivate()}
          >
              <span>
                <i className="mdi mdi-skip-next font-size-15 me-1"></i>
              </span>{" "}
            Add the next activity to homework
          </DropdownItem>}

          {previewActivity?.enabled && <DropdownItem
            onClick={() => previewActivity.onActivate()}
          >
              <span>
                <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
              </span>{" "}
            Preview
          </DropdownItem>
          }

          {edit?.enabled && <DropdownItem
            onClick={() => edit.onActivate()}
          >
              <span>
                <i className="mdi mdi-pencil font-size-15 me-1"></i>
              </span>{" "}
            Edit
          </DropdownItem>
          }

          {viewActivity?.enabled && <DropdownItem
            onClick={() => viewActivity.onActivate()}
          >
              <span>
                <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
              </span>{" "}
            View Activities
          </DropdownItem>
          }

          {addNewTask?.enabled && <DropdownItem
            onClick={() => addNewTask.onActivate()}
          >
              <span>
                <i className="mdi mdi-text-box-check-outline font-size-15 me-1"></i>
              </span>{" "}
            Add New Task
          </DropdownItem>
          }

          {addComment?.enabled && <DropdownItem
            onClick={() => addComment.onActivate()}
          >
              <span>
                <i className="mdi mdi-comment-outline font-size-15 me-1"></i>
              </span>{" "}
            Add Comment
          </DropdownItem>
          }

          {moveToLessonPlan?.enabled && <DropdownItem
            onClick={() => moveToLessonPlan.onActivate()}
          >
              <span style={{position: "relative"}}>
                <i className="mdi mdi-book-open-outline font-size-15 me-1" style={{position: "absolute", left: '0'}}></i>
                <i className="mdi mdi-arrow-right  font-size-15 me-1" style={{position: "absolute", left: '-12px'}}></i>
              </span>{" "}
            <span style={{marginLeft: '20px'}}>Move To Lesson Plan</span>
          </DropdownItem>
          }

          {moveToHomework?.enabled && <DropdownItem
            onClick={() => moveToHomework.onActivate()}
          >
              {/*<span>*/}
              {/*  <i className="mdi mdi-home-export-outline font-size-15 me-1"></i>*/}
              {/*</span>{" "}*/}
            <span style={{position: "relative"}}>
                <i className="mdi mdi-home-edit-outline font-size-15 me-1"  style={{position: "absolute", left: '0'}}></i>
                <i className="mdi mdi-arrow-right  font-size-15 me-1" style={{position: "absolute", left: '-12px'}}></i>
            </span>{" "}

            <span  style={{marginLeft: '20px'}}>Move To Homework</span>
          </DropdownItem>
          }

          {deleteActivity?.enabled && <DropdownItem
            onClick={() => deleteActivity.onActivate()}
          >
              <span>
                <i className="far fa-trash-alt font-size-15 me-1"></i>
              </span>{" "}
            Delete
          </DropdownItem>
          }
        </DropdownMenu>
      </Dropdown>

    </>
  )

}

